import split from 'lodash/split';
import forEach from 'lodash/forEach';
import isString from 'lodash/isString';

const stringsToRemove = [
  '<br/>',
  '<br />',
];

export default (text, opts = {}) => {
  if (!isString(text)) {
    return console.error(`formatMessage.js received
      ${typeof text} instead of string: ${text}`);
  }
  forEach(stringsToRemove, (str) =>
    text = split(text, str).join(opts.replaceWith || '\n'));
  return text;
};



/** WEBPACK FOOTER **
 ** ./src/logic/formatMessage.js
 **/